import React from 'react'
import { useDispatch } from 'react-redux'
import { logout } from '../redux/reducer/reducer'
import { useNavigate } from 'react-router-dom'
const Logout = ({setShowLogout}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()


  const handleLogout = () => {
    dispatch(logout())
    navigate('/login')
  }

  return (
    <>

<div  className=' position-fixed  start-0  top-0 w-100 h-100 d-flex  justify-content-center modal-box z-3'>
  <div className="modal-dialog  ">
    <div className="modal-content bg-white p-4 mt-2  rounded-1 ">
      <div className="modal-header  justify-content-center  ">
      <i className="me-1 fa-solid fa-right-from-bracket text-danger fs-2 "></i>
      </div>
      <div className="modal-body text-center">
        <p>
        Are you sure you want to Logout
        </p>
        <button type="button" className="mx-1 bg-danger-subtle btn px-5"  onClick={() => setShowLogout(false)}>No</button>
        <button type="button" className="mx-1 btn bg-danger  text-white  px-5" onClick={handleLogout}>Yes</button>
        </div>
    </div>
  </div>
</div>
    
    </>
  )
}

export default Logout